import React from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

import styles from 'assets/jss/material-dashboard-pro-react/components/loaderOverlayStyle.js';
import PropTypes from 'prop-types';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import cx from 'classnames';

const useStyles = makeStyles(styles);

export default function Overlay({
  type,
  message,
  dismiss,
  rootClasses,
  containerClasses,
  ...rest
}) {
  const classes = useStyles();
  return (
    <div className={`${classes.root} ${rootClasses || ''}`}>
      <div className={`${classes.container} ${containerClasses || ''}`}>
        {type === 'loading' && (
          <CircularProgress
            className={classes.item + ' ' + classes.spinner}
            {...rest}
          />
        )}
        {type === 'success' && (
          <CheckCircleOutlineIcon
            className={classes.item + ' ' + classes.success}
            {...rest}
          />
        )}
        {type === 'error' && (
          <ErrorOutlineIcon
            className={classes.item + ' ' + classes.error}
            {...rest}
          />
        )}
        {message && <span className={classes.item}>{message}</span>}
        {dismiss && <div>{dismiss}</div>}
      </div>
    </div>
  );
}

Overlay.propTypes = {
  type: PropTypes.oneOf(['loading', 'success', 'error']),
  message: PropTypes.string,
  size: PropTypes.number
};
